<template>
  <a-button
    size="large"
    class="mt-5"
    @click="exportWatchface"
    @focus="(e:UIEvent)=>{(e.target as HTMLElement).blur();}"
  >
    导出
  </a-button>

  <!-- 表盘导出成功页面 -->
  <ModalExportSuccess ref="exportSuccessRef" />
</template>

<script setup lang="ts">
import { useWatchfaceExport } from '@/hooks';
import { ref } from 'vue';
const exportSuccessRef = ref();
const binFile = ref('');
const visible = ref(false);
const onSuccess = ref<(bin: string) => void>();

const { pickThenExportWatchface } = useWatchfaceExport();
const exportWatchface = async () => {
  const {
    binPath,
    success: _success = false,
    mwzBlob,
    error
  } = (await pickThenExportWatchface()) ?? {};
  if (!_success) throw error;
  if (!binPath) throw error ?? '未获取到binPath';

  binFile.value = binPath;

  if (onSuccess.value) {
    visible.value = false;
    onSuccess.value?.(binPath);
  } else {
    visible.value = false;
    exportSuccessRef.value?.open(binPath, mwzBlob);
  }
};
</script>
